__webpack_require__.p = "https://class.baktimulya400.sch.id/";